import PouchDB from 'pouchdb'
import sqlite from 'pouchdb-adapter-cordova-sqlite'
import { boot } from 'quasar/wrappers'
import { differenceWith, forEach, uniqBy } from 'lodash'

let placesCollection = null
let residencesCollection = null
let agenciesCollection = null
let auditsCollection = null
var isCordova = false

const localOptions = () => {
  let options = { auto_compaction: true }
  if (isCordova) {
    PouchDB.plugin(sqlite)
    options = {
      auto_compaction: true,
      adapter: 'cordova-sqlite',
      location: 'default'
    }
  }
  return options
}

const $patrimoine = {
  initLocal: (cordova) => {
    isCordova = cordova
    placesCollection = new PouchDB('places.db', localOptions())
    placesCollection.createIndex({
      index: { fields: ['residence'] }
    })
    residencesCollection = new PouchDB('residences.db', localOptions())
    residencesCollection.createIndex({
      index: { fields: ['agency'] }
    })
    agenciesCollection = new PouchDB('agencies.db', localOptions())
    auditsCollection = new PouchDB('audits.db', localOptions())
    auditsCollection.createIndex({
      index: { fields: ['id'] }
    })
  },
  emptyDB: async (db) => {
    if (!db) return
    try {
      await db.destroy()
    } catch (err) {
      console.error('err destroy', {
        db: db.name,
        err
      })
    }
  },
  resetLocalDBs: async (isCordova) => {
    await Promise.all([
      $patrimoine.emptyDB(placesCollection),
      $patrimoine.emptyDB(residencesCollection),
      $patrimoine.emptyDB(agenciesCollection),
      $patrimoine.emptyDB(auditsCollection)
    ])
    $patrimoine.initLocal(isCordova)
  },
  async storePlaces(inputs) {
    let places = []
    let residences = []
    let agencies = []

    const storedAgencies = (await agenciesCollection.allDocs()).rows
    const storedResidences = (await residencesCollection.allDocs()).rows

    forEach(inputs, (input) => {
      let { residence, type: typePlace, ...newPlace } = input
      let { agency, type: typeResidence, ...newResidence } = input.residence
      let { type: typeAgence, ...newAgency } = input.residence.agency

      newPlace = {
        _id: newPlace.id,
        name: newPlace.name,
        residence: newResidence.id,
        spots: newPlace.spots.map((spot) => {
          return {
            id: spot.id,
            name: spot.name,
            category: {
              id: spot.category.id
            }
          }
        })
      }
      places.push(newPlace)

      newResidence = {
        _id: newResidence.id,
        name: newResidence.name,
        agency: newAgency.id
      }
      residences.push(newResidence)
      residences = uniqBy(residences, (r) => r._id)
      residences = differenceWith(
        residences,
        storedResidences,
        (residence, storedResidence) => {
          return residence._id === storedResidence.id
        }
      )

      newAgency = {
        _id: newAgency.id,
        name: newAgency.name
      }
      agencies.push(newAgency)
      agencies = uniqBy(agencies, (a) => a._id)
      agencies = differenceWith(
        agencies,
        storedAgencies,
        (agency, storedAgency) => {
          return agency._id === storedAgency.id
        }
      )
    })

    await agenciesCollection.bulkDocs(agencies)
    await residencesCollection.bulkDocs(residences)
    await placesCollection.bulkDocs(places)
  },
  async addSpotsToPlace(placeId, spots) {
    const place = await placesCollection.get(placeId)
    if (!place) throw 'Place not found'
    place.spots = [...place.spots, ...spots]
    await placesCollection.put(place)
  },
  agenciesCollection: () => agenciesCollection,
  residencesCollection: () => residencesCollection,
  placesCollection: () => placesCollection,
  auditsCollection: () => auditsCollection,
  clearAuditsCollection: async () => {
    await $patrimoine.emptyDB(auditsCollection)
    auditsCollection = new PouchDB('audits.db', localOptions())
  },
  async addSpotsToPlace(placeId, spots) {
    const place = await placesCollection.get(placeId)
    if (!place) throw 'Place not found'
    place.spots = [...place.spots, ...spots]
    await placesCollection.put(place)
  },
  agenciesCollection: () => agenciesCollection,
  residencesCollection: () => residencesCollection,
  placesCollection: () => placesCollection,
  async deletePlaceCascade(place, cascade) {
    if (!place?._id) {
      throw 'place?._id is undefined'
    }
    await placesCollection.get(place._id).then((doc) => {
      return placesCollection.remove(doc)
    })
    if (cascade.includes('residence') && place.residence) {
      const places = await placesCollection.find({
        selector: { residence: place.residence }
      })

      if (!places?.docs?.length) {
        const residence = await residencesCollection
          .get(place.residence)
          .then(async (residence) => {
            await residencesCollection.remove(residence)
            return residence
          })

        if (cascade.includes('agency') && residence.agency) {
          const residences = await residencesCollection.find({
            selector: { agency: residence.agency }
          })
          if (!residences?.docs?.length) {
            await agenciesCollection.get(residence.agency).then((agency) => {
              return agenciesCollection.remove(agency)
            })
          }
        }
      }
    }
  }
}

export default boot(({ app }) => {
  app.config.globalProperties.$patrimoine = $patrimoine
  app.provide('$patrimoine', $patrimoine)
})

export { $patrimoine }
